@if (!isOuraFlow) {
  <app-progress-indicator [page]="Page.measuringDevice" />
}

<app-discount-banner [centered]="true" [topMargin]="true" [bottomMargin]="!isOuraFlow" />
@if (isOuraFlow) {
  <div class="ouraPage ouraPage___dark">
    <app-oura-entrance (ouraSelected)="onOuraSelected($event)" />
  </div>
} @else {
  <div
    class="measuringDevice measuringDevice___light"
    [ngClass]="
      measuringDevices().length % 3
        ? 'measuringDevice___twoColumns'
        : 'measuringDevice___threeColumns'
    "
    [@fadeAnimation]
  >
    <div class="measuringDevice__wrapper">
      <h2 class="measuringDevice__title">
        {{ 'measuringDevice-page-title' | translate }}
      </h2>

      <p class="measuringDevice__subTitle">
        {{ 'txt-effectiveness-remains-the-same' | translate }}
      </p>

      @if (hasLoadedDevices) {
        <div class="measuringDevice__cardsWrapper">
          @for (measuringDevice of measuringDevices(); track measuringDevice) {
            @if (isAb411()) {
              <app-measuring-device-card-revamped
                [product]="measuringDevice"
                (deviceSelected)="onDeviceSelected($event)"
              />
            } @else {
              <app-measuring-device-card
                [product]="measuringDevice"
                (deviceSelected)="onDeviceSelected($event)"
              />
            }
          }
        </div>
      }

      <div class="accordion">
        <app-accordion [theme]="AccordionTheme.Light">
          <accordion-item>
            <ng-template accordionHeader>
              <span style="font-weight: bold">
                {{ 'measuring-device-which-device-title' | translate }}
              </span>
            </ng-template>
            <ng-template accordionContent>
              <div
                class="accordion__content"
                [innerHTML]="
                  b1Available()
                    ? ('txt-can-not-decide-section-b1-in-signup' | tmd)
                    : ('txt-can-not-decide-section' | tmd)
                "
              ></div>
              @for (measuringDevice of measuringDevices(); track measuringDevice) {
                <div
                  class="accordion__content"
                  [innerHTML]="'measuring-device-which-device--' + measuringDevice.key | tmd"
                ></div>
              }
            </ng-template>
          </accordion-item>
        </app-accordion>
      </div>
    </div>
  </div>
}
